/* Zeelar photo strip (redesign 2026-09-30). The marquee itself is CSS; this only
   runs it while the strip is on screen (.is-on) and loads the photos just before
   the strip scrolls into view, so none slide in blank. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const load = (el) => {
    const sel = reduce.matches ? '.zs-list:not([aria-hidden]) img' : 'img';
    el.querySelectorAll(sel).forEach((img) => { if (window.zHydrate) window.zHydrate(img); img.loading = 'eager'; });
  };
  const hasIO = 'IntersectionObserver' in window;
  const run = hasIO && new IntersectionObserver((entries) => {
    entries.forEach((e) => e.target.classList.toggle('is-on', e.isIntersecting));
  });
  const pre = hasIO && new IntersectionObserver((entries, obs) => {
    entries.forEach((e) => { if (e.isIntersecting) { load(e.target); obs.unobserve(e.target); } });
  }, { rootMargin: '600px 0px' });
  const init = (root) => {
    root.querySelectorAll('[data-z-strip]').forEach((el) => {
      if (el.dataset.zInit) return;
      el.dataset.zInit = '1';
      if (!hasIO) { el.classList.add('is-on'); load(el); return; }
      run.observe(el);
      pre.observe(el);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
